import axios from 'axios'
import router from '../router/index.js'

const Http = { 
}

// axios.defaults.baseURL='http://localhost:8081/newretail'; 
//axios.defaults.baseURL='http://192.168.0.188:8081/newretail'; 

//axios.defaults.baseURL='http://118.31.20.93:8081/newretail'; 
axios.defaults.baseURL='https://newretail.vifulink.com'; 

// 添加请求拦截器
axios.interceptors.request.use(config=>{  
	//config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	// console.log("===================请求拦截 添加TOKEN============================");
	if(localStorage.getItem('TOKEN')){
		config.headers.token = localStorage.getItem('TOKEN');
		// config.headers.Authorization = localStorage.getItem('TOKEN');
	}else{
		config.headers.token = '';
		// config.headers.Authorization = '';
	}
	
	
	//console.log("============================请求拦截=================================");
	//console.log(config);
	//console.log("============================请求拦截=================================");
	return config;
},err=>{
	// 关闭全局loading提示
	// 给出错误提示
	console.log(err);
});


// 添加响应拦截器
axios.interceptors.response.use(response=>{
	
	
	
	//console.log("============================响应拦截=================================");
	//console.log(response);
	//console.log("============================响应拦截=================================");
	let reData = response.data;
	// 若当前返回的相应code为401 则表示Token已过期，需要清除localstorage中的TOKEN,并返回到登录页面
	if(401 == reData.code){
		localStorage.removeItem('TOKEN');
		localStorage.removeItem('CUSER_ID');
		localStorage.removeItem('CUSER_NAME'); 
		localStorage.removeItem('CUSER_NIKENAME'); 
		  
		//router.push('/login');
		router.push('/');
		return response.data;
	}else{
		return response.data;
	}
},err=>{
	console.log(err);
});

export default Http;